import {ReactElement} from 'react'
import {Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography} from '@material-ui/core'
import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import {Account} from '../../../../../../../graphql/types'
import messages from '../../../../../../../assets/messages'
import {useProvider} from '../../../../../Forex/hooks/useProvider'
import {getMetadataFromAccount} from '../../../../../../../common/utils/accounts'
import Loading from '../../../../../../Common/Loading'
import NotificationBar from '../../../../../../Common/NotificationBar'
import {formatDate, formatPercent} from '../../../../../../../common/utils'
import {useStyles} from './styles'

type StrategyInfoProps = {
  account: Account
} & WithNamespaces

export function StrategyInfoBase(props: StrategyInfoProps): ReactElement {
  const {account, lng} = props
  const {latestPerformanceFeeDate} = account

  const brokereeProviderAccountId = getMetadataFromAccount(account).brokereeProviderAccountId as number
  const {loading, provider} = useProvider(brokereeProviderAccountId)

  const classes = useStyles()

  if (loading) return <Loading />
  if (provider == null || provider.offer == null) return (
    <Grid>
      <NotificationBar status="error">
        <Trans {...messages.generalError} />
      </NotificationBar>
    </Grid>
  )

  return (
    <Grid container>
      <Typography variant="h3"><Trans {...messages.strategyDetails} /></Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.header}><Trans {...messages.name} /></TableCell>
            <TableCell className={classes.header}><Trans {...messages.performanceFee} /></TableCell>
            <TableCell className={classes.header}><Trans {...messages.activeSince} /></TableCell>
            <TableCell className={classes.header}><Trans {...messages.lastFeeCollectedDate} /></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell className={classes.content}>
              {provider.offer.name}
            </TableCell>
            <TableCell className={classes.content}>
              {formatPercent(lng, provider.offer.performanceFee)}
            </TableCell>
            <TableCell className={classes.content}>
              {provider.startedAt != null ? (
                formatDate(lng, provider.startedAt, {dateStyle: 'long'})
              ) : (
                <Trans {...messages.disabled} />
              )}
            </TableCell>
            <TableCell className={classes.content}>
              {latestPerformanceFeeDate != null ? (
                formatDate(lng, latestPerformanceFeeDate, {dateStyle: 'long', timeStyle: 'short'})
              ) : (
                '-'
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Grid>
  )
}

export const StrategyInfo = withNamespaces()(StrategyInfoBase)
